import React from 'react';
import Modal from './Modal';
import { Body2Regular, Body3Regular, Subtitle1Bold } from '../../lib/font';
import { Col } from '../../lib/utils';
import { colors } from '../../lib/colors';

type Props = {
    progress: number; // 0 ~ 100
    memberCount: number;
    isWaiting: boolean; // 가상 진행률 100% 이후 API 대기 상태
};

const ModalMemberListProgress = ({ progress, memberCount, isWaiting }: Props) => {
    return (
        <Modal whiteViewWidth={480} whiteViewHeight={260} isCloseOutside={false}>
            <Col className="p-[24px]">
                <Subtitle1Bold className="text-LAVEL_4 mb-[8px]">담당 강사 변경 중</Subtitle1Bold>
                <Body3Regular className="text-LAVEL_3 mb-[16px]">
                    총 {memberCount}명의 회원을 처리하고 있어요. 브라우저를 닫지 마세요.
                </Body3Regular>

                <Col className="w-full mb-[8px]">
                    <div className="w-full h-[12px] bg-WHITE_500 rounded-[6px] overflow-hidden">
                        <div
                            className="h-full bg-primary rounded-[6px] transition-[width] duration-100 ease-linear"
                            style={{
                                width: `${Math.min(100, Math.max(0, progress))}%`,
                                backgroundColor: colors.primary,
                            }}
                        />
                    </div>
                </Col>
                <Body2Regular className="text-LAVEL_4 mb-[4px]">{Math.floor(progress)}%</Body2Regular>
                {isWaiting ? (
                    <Body3Regular className="text-LAVEL_3">100% 완료되었습니다. 잠시만 더 기다려주세요…</Body3Regular>
                ) : (
                    <Body3Regular className="text-LAVEL_3">진행 중입니다…</Body3Regular>
                )}
            </Col>
        </Modal>
    );
};

export default ModalMemberListProgress;
